import _ from "lodash";
import {firebaseStorage, storageRef} from "../../firebase/client-app";
import {getDownloadURL} from "@firebase/storage";
import reactImageSize from 'react-image-size';
import axios from "axios";
import {getExternalImageDownloadUrl} from "../services/cloud-function-service";

export {
    resizeDataURL,
    getImageDownloadUrl,
    getImageDownloadUrlFromFullPath,
    getImageDataUrl,
    setImageSize,
}

const getImageDataUrl = (url) => {
    return new Promise(async function (resolve, reject) {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        const img = new Image();

        // const imageBlob = await axios.get('http://127.0.0.1:5001/leafy-orb-genie-dev/us-central1/getImageDataUrl?url=' + url, {responseType: 'blob'});
        const downloadUrl = await getExternalImageDownloadUrl(url);

        console.log('downloadUrl: ', downloadUrl);

        img.onload = function () {
            canvas.width = img.width;
            canvas.height = img.height;
            context.drawImage(img, 0, 0);

            const dataURL = canvas.toDataURL('image/png'); // Change 'image/jpeg' to the appropriate image MIME type if needed

            const link = document.createElement('a');
            link.href = dataURL;
            link.download = 'image.png'; // Specify the desired file name and extension

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        };

        img.src = downloadUrl;
    })
}

const resizeDataURL = (dataUriInput, wantedWidth, wantedHeight) => {
    return new Promise(async function (resolve, reject) {
        let img = document.createElement('img');
        img.onload = function () {
            let canvas = document.createElement('canvas');
            let ctx = canvas.getContext('2d');
            canvas.width = wantedWidth;
            canvas.height = wantedHeight;
            // @ts-ignore
            ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);
            let dataURI = canvas.toDataURL();
            resolve(dataURI);
        };

        img.src = dataUriInput;
    })
}

const getImageDownloadUrl = async (imageDetail) => {
    return new Promise<void>(async (resolve) => {
        const fileRef = storageRef(firebaseStorage, imageDetail.name);
        // imageDetail.downloadUrl = await getDownloadURL(fileRef).then();

        await getDownloadURL(fileRef)
            .then(downloadUrl => {
                imageDetail.downloadUrl = downloadUrl;
                resolve();
            })
            .catch(errorMessage => {
                console.log('errorMessage: ', errorMessage);
                resolve();
            })

    });
}

const getImageDownloadUrlFromFullPath = async (imageDetail) => {
    return new Promise<void>(async (resolve) => {
        const fileRef = storageRef(firebaseStorage, imageDetail?.fullPath);
        // imageDetail.downloadUrl = await getDownloadURL(fileRef).then();

        await getDownloadURL(fileRef)
            .then(downloadUrl => {
                imageDetail.downloadUrl = downloadUrl;
                resolve();
            })
            .catch(errorMessage => {
                console.log('errorMessage: ', errorMessage);
                resolve();
            })

    });
}

const setImageSize = (imageDetail) => {
    return new Promise<void>((resolve) => {
        if (imageDetail && (!imageDetail.width || !imageDetail.height)) {
            reactImageSize(imageDetail.downloadUrl)
                .then(({width, height}) => {
                    imageDetail.width = width;
                    imageDetail.height = height;

                    resolve();
                })
                .catch((errorMessage) => {
                    console.log('errorMessage: ', errorMessage);
                });
        } else {
            resolve();
        }
    });
}
